(() => {
    for (let i = 1; i <= 4; i += 1) {
        const headlines = document.querySelectorAll(`.rich-text h${i}`);

        headlines.forEach((headline) => {
            headline.classList.add(`headline-${i}`);
        });
    }
})();
